import { styled } from '@mui/material/styles';

export const AuthFooterLinksRoot = styled('footer')(({ theme }) => ({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  flexShrink: 0,
  flexWrap: 'wrap',
  gap: theme.spacing(1, 2.5),
  justifyContent: 'space-between',
  marginInline: 'auto',
  maxWidth: '100%',
  paddingBottom: `calc(${theme.spacing(3)} + env(safe-area-inset-bottom, 0px))`,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    textAlign: 'center',
    paddingTop: theme.spacing(2),
  },
}));

export const AuthFooterLinksGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.75, 2.5),
  justifyContent: 'flex-start',
  maxWidth: '100%',
  '&:last-of-type': {
    justifyContent: 'flex-end',
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
    justifyContent: 'center',
    width: 'auto',
    '&:last-of-type': {
      justifyContent: 'center',
    },
  },
}));
